var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoldRupeMd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 55,
    viewBox: "0 0 54 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_145_549)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 25,
    r: 15.9223,
    fill: "url(#paint0_linear_145_549)",
    stroke: "url(#paint1_linear_145_549)",
    strokeWidth: 2.15531
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.9181,
    cy: 24.917,
    r: 15.076,
    fill: "url(#paint2_linear_145_549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0644 32.7273L22.3635 26.2706V24.7489H23.5971C24.0906 24.7489 24.5224 24.6804 24.8925 24.5433C25.2762 24.3925 25.5915 24.18 25.8382 23.9059C26.0987 23.6317 26.2768 23.3027 26.3728 22.9188H22.3635V21.3972H26.3522C26.27 21.0408 26.1261 20.7255 25.9205 20.4513C25.7286 20.1771 25.4681 19.9647 25.1392 19.8139C24.8239 19.6494 24.4401 19.5671 23.9878 19.5671H22.3635V18.0455H31.6363V19.5671H28.4083C28.6413 19.8276 28.8332 20.1086 28.984 20.4102C29.1484 20.7118 29.2581 21.0408 29.3129 21.3972H31.6363V22.9188H29.3541C29.217 23.9333 28.8263 24.7284 28.1821 25.3041C27.5379 25.8662 26.7086 26.25 25.6943 26.4556L29.7241 32.7273H26.0644Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_145_549",
    x: 0.0209131,
    y: 0.294054,
    width: 53.9582,
    height: 53.9582,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.27314
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.98954
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_145_549"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_145_549",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_145_549",
    x1: 43.32,
    y1: 41.32,
    x2: 12.72,
    y2: 9.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD9F4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5E1C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_145_549",
    x1: 14.25,
    y1: 15.0833,
    x2: 34.0833,
    y2: 35.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD9F4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5E1C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_145_549",
    x1: 19.2048,
    y1: 18.6233,
    x2: 39.7465,
    y2: 41.9983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD9F4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5E1C1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldRupeMd);
export default __webpack_public_path__ + "static/media/gold_rupe_md.3d90841fea1ecdc4081277b4741f8afe.svg";
export { ForwardRef as ReactComponent };